import { fillArticleNumberField } from './ProductEnquiryArticleData';

/**
 * Work around a defect because we use Bootstrap 4.0.0-alpha 2 styles, but Bootstrap 4.3.1 JS.
 */
$('#product-contact-form')
    .on('shown.bs.modal', function (event) {
        fillArticleNumberField(event);

        const modal = $(this);
        const backdrop = $('.modal-backdrop');

        modal.addClass('in');
        backdrop.addClass('in');
    })
    .on('hide.bs.modal', function () {
        const modal = $(this);
        const backdrop = $('.modal-backdrop');

        modal.removeClass('in');
        backdrop.removeClass('in');
    });
